type State = Record<string, unknown>;

const state: State = {};

const getters = {};

const mutations = {};

const actions = {};
export default {
  state,
  getters,
  mutations,
  actions,
};
